import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import Dropdown from "react-bootstrap/Dropdown";
import Logo from "../components/Logo";
import SidebarModal from "../components/Common/SidebarModal";
import BeneficiaryDropdown from "../components/BeneficiaryDropdown";
import { PublicApi } from "api/api";
import { useTranslation } from "react-i18next"; 

const publicApi = new PublicApi();

function Header() {
  const location = useLocation();
  const { i18n, t } = useTranslation();

  const [selectedLanguage, setSelectedLanguage] = useState(localStorage.getItem("i18nextLng") || "EN");
  const [languageList,setLangaugeList] = useState([])
  const handleSelect = (language) => {
    setSelectedLanguage(language);
  };

  const getAllLanguage = async () => {
    const response = await publicApi.apiPublicGetAllLanguage();
    setLangaugeList(response?.data)
  }


  const [isHeaderFixed, setIsHeaderFixed] = useState(false);
  useEffect(() => {
    getAllLanguage()
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setIsHeaderFixed(true);
      } else {
        setIsHeaderFixed(false);
      }
    };
    window.scrollTo(0, 0);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };

  }, []);
  // {languages.map((language) => {
  //   const isDefaultLanguage = language?.i18nCode?.code === i18n?.language;
  //   return (
  //     <Link
  //       onClick={() => onFlagChangeHandle(language?.i18nCode?.code)}
  //       to="#"
  //       key={language?.i18nCode?.code}
  //       style={{
  //         backgroundColor: isDefaultLanguage ? theme["linkActive"] : "",
  //       }}
  //     >
  //       <span className={isDefaultLanguage ? "ant-menu-item-selected" : ""}>
  //         {language?.i18nCode?.name}
  //       </span>
  //     </Link>
  //   );
  // })}

  const languageMenu = (
    <Dropdown.Menu>
      {languageList?.map(lang => {
        return  <Dropdown.Item
        key={lang?.i18nCode?.code}
        active={selectedLanguage === lang?.i18nCode?.code}
        onClick={() =>
          handleLanguage(lang?.i18nCode?.code, lang.i18nCodeId)
        }
      >
        {lang?.i18nCode?.name}
      </Dropdown.Item>
      })}
    
    </Dropdown.Menu>
  );

  const handleLanguage = (lng, id) => {
    setSelectedLanguage(lng);
    localStorage.setItem("i18nextLng", lng);
    localStorage.setItem("i18nextLanguageId", id);
    i18n.changeLanguage(lng);
  };



  return (
    <header className={`header-wrapper ${isHeaderFixed ? "header-fixed" : ""}`}>
      <div className="header-menu">
        {/* <Logo /> */}<div></div>
        <ul className="nav-menu">
          <li>
            <Link
              to="/"
              className={`${location?.pathname === "/" ? "active" : ""}`}
            >
              {t('header-nav:home','Home')}
            </Link>
          </li>
          <li>
            <BeneficiaryDropdown dropdownTitle={t('header-nav:beneficiary','Beneficiary')} />
          </li>
          <li>
            <Link to="/legislation" className={`${location?.pathname === "/legislation" ? "active" : ""}`}>
            {t('header-nav:legislation','Legislation')}
          
              </Link>
          </li>
          <li>
            <Link to="/contact-us" className={`${location?.pathname === "/contact-us" ? "active" : ""}`}>
            {t('header-nav:contact-us','Contact Us')}
              </Link>
          </li>
          <li>
            <Dropdown className="dropdown-language">
              <Dropdown.Toggle id="dropdown-language">
                <svg
                  width="22"
                  height="22"
                  viewBox="0 0 22 22"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.989 0C4.917 0 0 4.928 0 11C0 17.072 4.917 22 10.989 22C17.072 22 22 17.072 22 11C22 4.928 17.072 0 10.989 0ZM18.612 6.6H15.367C15.015 5.225 14.509 3.905 13.849 2.684C15.873 3.377 17.556 4.785 18.612 6.6ZM11 2.244C11.913 3.564 12.628 5.027 13.101 6.6H8.899C9.372 5.027 10.087 3.564 11 2.244ZM2.486 13.2C2.31 12.496 2.2 11.759 2.2 11C2.2 10.241 2.31 9.504 2.486 8.8H6.204C6.116 9.526 6.05 10.252 6.05 11C6.05 11.748 6.116 12.474 6.204 13.2H2.486ZM3.388 15.4H6.633C6.985 16.775 7.491 18.095 8.151 19.316C6.127 18.623 4.444 17.226 3.388 15.4ZM6.633 6.6H3.388C4.444 4.774 6.127 3.377 8.151 2.684C7.491 3.905 6.985 5.225 6.633 6.6ZM11 19.756C10.087 18.436 9.372 16.973 8.899 15.4H13.101C12.628 16.973 11.913 18.436 11 19.756ZM13.574 13.2H8.426C8.327 12.474 8.25 11.748 8.25 11C8.25 10.252 8.327 9.515 8.426 8.8H13.574C13.673 9.515 13.75 10.252 13.75 11C13.75 11.748 13.673 12.474 13.574 13.2ZM13.849 19.316C14.509 18.095 15.015 16.775 15.367 15.4H18.612C17.556 17.215 15.873 18.623 13.849 19.316ZM15.796 13.2C15.884 12.474 15.95 11.748 15.95 11C15.95 10.252 15.884 9.526 15.796 8.8H19.514C19.69 9.504 19.8 10.241 19.8 11C19.8 11.759 19.69 12.496 19.514 13.2H15.796Z"
                    fill="#0E4194"
                  />
                </svg>
                {selectedLanguage.toUpperCase()}
              </Dropdown.Toggle>
            {languageMenu }
            </Dropdown>
          </li>
        </ul>
        <div className="hamburger_menu">
          <SidebarModal languageList={languageList} />
        </div>
      </div>
    </header>
  );
}

export default Header;
